jQuery( document ).ready( function( $ ) {
	$( '#wpforms-form-182' ).on( 'wpformsAjaxSubmitSuccess', function() {
		dataLayer.push( {
			event: 'form_complete',
			form_name: 'contact us',
		} );
	} );
} );
